module.exports = __webpack_public_path__ + "static/img/app-img-01@t.274dbe7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/glovis-aa/app-img-01@t.png
// module id = Oj5l
// module chunks = 0